<template>
  <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
    <md-card>
      <md-card-header data-background-color="green">
        <h4 class="title">Your Websites</h4>
        <p class="category">These are your websites</p>
      </md-card-header>
      <md-card-content>
        <md-table>
          <md-table-row>
            <md-table-head>Website URL</md-table-head>
          </md-table-row>

          <md-table-row v-for="source in get_sources">
            <md-table-cell>{{source}}</md-table-cell>
          </md-table-row>
        </md-table>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import {API} from '../../services';

    export default {
        name: 'UserSourceList',
        computed: {
            ...mapGetters(["get_sources"]),
        },
    };
</script>
